const e = {
  getV1TenantChecks: {
    schema: {
      method: "get",
      url: "/v1/tenant-checks"
    }
  },
  getV1ProfilesOwneridTenantChecksSummary: {
    schema: {
      method: "get",
      url: "/v1/profiles/{ownerId}/tenant-checks-summary"
    }
  },
  postV1ProfilesOwneridTenantChecks: {
    schema: {
      method: "post",
      url: "/v1/profiles/{ownerId}/tenant-checks",
      mediaType: "application/json"
    }
  },
  getV1ProfilesOwneridTenantChecks: {
    schema: {
      method: "get",
      url: "/v1/profiles/{ownerId}/tenant-checks"
    }
  },
  postV1ProfilesOwneridLaunch: {
    schema: {
      method: "post",
      url: "/v1/profiles/{ownerId}/launch",
      mediaType: "application/json"
    }
  },
  getV1ProfilesOwneridVerifications: {
    schema: {
      method: "get",
      url: "/v1/profiles/{ownerId}/verifications"
    }
  },
  postV1ProfilesOwneridVerifyCommunicationCode: {
    schema: {
      method: "post",
      url: "/v1/profiles/{ownerId}/verify-communication-code",
      mediaType: "application/json"
    }
  },
  postV1ProfilesOwneridRestartVerification: {
    schema: {
      method: "post",
      url: "/v1/profiles/{ownerId}/restart-verification",
      mediaType: "application/json"
    }
  },
  postV1ProfilesOwneridRequestVerificationCode: {
    schema: {
      method: "post",
      url: "/v1/profiles/{ownerId}/request-verification-code",
      mediaType: "application/json"
    }
  },
  getV1VerificationTypes: {
    schema: {
      method: "get",
      url: "/v1/verification-types"
    }
  },
  getV1ProfilesOwneridVerificationsIntent: {
    schema: {
      method: "get",
      url: "/v1/profiles/{ownerId}/verifications/{intent}"
    }
  }
};
export {
  e as v1Service
};
